import React from 'react'
import { storiesOf } from '@storybook/react'

import Avatar from '@material-ui/core/Avatar'
import Badge from 'components/Badge'

storiesOf('Badge', module)
  .add('default', () => (
    <Badge badgeContent={12} color="primary">
      <Avatar src="http://i.pravatar.cc/128" />
    </Badge>
  ))
